import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  ngOnInit() {
    const cc = window as any;

    cc.cookieconsent.initialise({
      position: 'bottom',
      theme: 'classic',
      content: {
        message:
          'Dette websted bruger cookies for at sikre, at du får den bedste oplevelse på vores hjemmeside.',
        dismiss: 'Forstået',
        link: 'Lær mere',
        href: '/privacy-policy' + window.location.search,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts